import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PluginConfigurationComponent } from '@valtimo/plugin';
import {
  BehaviorSubject,
  combineLatest,
  filter,
  map,
  Observable,
  Subscription,
  take,
} from 'rxjs';
import { DestructionProcedureConfig, DestructionProcedureType } from '../../models';
import { DestructionProcedurePluginService } from '../../services';

@Component({
  standalone: false,
  selector: 'valtimo-destructionProcedure-configuration',
  templateUrl: './destructionprocedure-configuration.component.html',
  styleUrls: ['./destructionprocedure-configuration.component.scss'],
})
export class DestructionProcedureConfigurationComponent
  implements PluginConfigurationComponent, OnInit, OnDestroy {
  @Input() save$: Observable<void>;
  @Input() disabled$: Observable<boolean>;
  @Input() pluginId: string;
  @Input() prefillConfiguration$: Observable<DestructionProcedureConfig>;
  @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() configuration: EventEmitter<DestructionProcedureConfig> = new EventEmitter<DestructionProcedureConfig>();

  mappedPrefill$: Observable<DestructionProcedureConfig>;

  private saveSubscription!: Subscription;

  private readonly formValue$ = new BehaviorSubject<DestructionProcedureConfig | null>(null);
  private readonly valid$ = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly destructionProcedurePluginService: DestructionProcedurePluginService
  ) { }

  ngOnInit(): void {
    this.openSaveSubscription();
    this.setMappedPrefill();
  }

  ngOnDestroy() {
    this.saveSubscription?.unsubscribe();
  }

  formValueChange(formValue: DestructionProcedureConfig): void {
    this.formValue$.next(formValue);
    this.handleValid(formValue);
  }

  destructionProcedureTypeFormChange(formValue: DestructionProcedureType): void {
  }

  private handleValid(formValue: DestructionProcedureConfig): void {
    const validForm = !!(
      formValue.configurationTitle
      && formValue.headInformationManagerUsername
      && formValue.archivalEmail
    );
    const destructionProcedureTypen = formValue.destructionProcedureProperties || [];
    const validDestructionProcedureTypen = destructionProcedureTypen.filter(
      type =>
        !!(
          type.departmentName &&
          type.departmentHeadUsername
        )
    );
    const valid = validForm && destructionProcedureTypen.length === validDestructionProcedureTypen.length;
    this.valid$.next(valid);
    this.valid.emit(valid);
  }

  private openSaveSubscription(): void {
    this.saveSubscription = this.save$?.subscribe(save => {
      combineLatest([this.formValue$, this.valid$])
        .pipe(take(1))
        .subscribe(([formValue, valid]) => {
          const formValueToSave: DestructionProcedureConfig = {
            ...formValue,
            destructionProcedureProperties: formValue.destructionProcedureProperties.map(destructionProcedure => {
              const destructionProcedureToReturn: DestructionProcedureType = { ...destructionProcedure };

              return {
                ...destructionProcedureToReturn,
              };
            }),
          };
          if (valid) {
            this.configuration.emit(formValueToSave);
          }
        });
    });
  }

  private setMappedPrefill(): void {
    this.mappedPrefill$ = this.prefillConfiguration$.pipe(
      filter(prefill => !!prefill),
      map(prefill => ({
        ...prefill,
        destructionProcedureProperties: prefill.destructionProcedureProperties.map(destructionProcedureType => ({
          ...destructionProcedureType,
        })),
      })),
    );
  }
}
